import { z } from 'zod';

import { CurationApiTypeSchema } from './create-curations.dto';

export const UpdateCurationsServiceRequestSchema = z
  .object({
    curationId: z.string(),
    title: z.string(),
    description: z.string(),
    goodsNoList: z.array(z.string()),
    /** OpenAPI `UpdateCurationV2Request.type` — 29CM 고정 GOODS, 무신사 GOODS/SNAP2 */
    type: CurationApiTypeSchema,
    /** OpenAPI `UpdateCurationV2Request.snapItems` — GOODS 수정 시 빈 배열 */
    snapItems: z.array(z.string()).optional(),
  })
  .describe('UpdateCurationsServiceRequestSchema');

export const UpdateCurationsServiceResponseSchema = z
  .object({
    success: z.boolean(),
    curationId: z.string(),
  })
  .describe('UpdateCurationsServiceResponseSchema');

export type UpdateCurationsServiceRequest = z.infer<typeof UpdateCurationsServiceRequestSchema>;
export type UpdateCurationsServiceResponse = z.infer<typeof UpdateCurationsServiceResponseSchema>;
